
<div class="card">
  <div class="card-body mb-2">

    <div class="row">
      <div class="col-md-12">
        <h4>Section {{ sectionData.sectionOrder }} - Training Video</h4>
        <p><b>Please watch the following information before proceeding</b></p>
        <video-player [src]="sectionData.videoUri" (onVideoEnd)="canProceed = true"></video-player>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <a [routerLink]="backLink" [queryParams]="{type: userCourseType}" class="secondary-link-btn">course overview</a>
        <button type="button" *ngIf="!isComplete" [disabled]="!canProceed" class="my-2 btn btn-round btn-sm btn-success float-right" (click)="submit()">Next</button>
        <button type="button" *ngIf="isComplete" class="my-2 btn btn-round btn-sm btn-primary float-right" (click)="onGoToNextSection.emit()">Next</button>
      </div>
    </div>
  </div>
</div>
